import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

/**
 * Audit Engine service.
 *
 * Grid data for both audit modes is fetched by AdminGridDirective via
 * GridFactory.loadGridData (parity with the legacy GridFactory.getDataCustom
 * call from auditCtrl.js). The only audit-specific endpoint that remains
 * here is the users dropdown loader used in User Audit mode.
 *
 * Legacy reference: GTW12/ui/app/components/admin/auditEngine/auditService.js
 *   AuditDataFactory.getAllUserNames → loadJsonObject?action_code=652qui
 */
@Injectable({ providedIn: 'root' })
export class AuditEngineService {
  constructor(private http: HttpClient) {}

  getAllUserNames(): Observable<any> {
    const url = `${environment.base_url}/loadJsonObject?action_code=652qui`;
    return this.http.get<any>(url, { withCredentials: true });
  }
}
